/**
 * API functions for Replenishment entity.
 */
import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type { FetchRequest, Replenishment, ReplenishmentInput, UUID } from "../base/ui_general/GeneralInterfaces";

export function getRequest_create_replenishment(replenishmentInput: ReplenishmentInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.REPLENISHMENT,
        method: HttpMethods.POST,
        query_parameters: {},
        body: replenishmentInput,
    };
}

export function getRequest_update_replenishment(replenishment: Replenishment): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.REPLENISHMENT,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: replenishment,
    };
}

export function getRequest_get_all_replenishments(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.REPLENISHMENT,
        method: HttpMethods.GET,
        query_parameters: { transaction_id },
    };
}
